/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetUploadIcon32Regular = forwardRef('NetUploadIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M7.664 10.748a1 1 0 0 1-1.328-1.495l7.006-6.229a4 4 0 0 1 5.315 0l7.007 6.229a1 1 0 0 1-1.328 1.495l-7.007-6.229A2.004 2.004 0 0 0 17 4.282V22.5a1 1 0 0 1-2 0V4.282a2.004 2.004 0 0 0-.329.237l-7.007 6.229Z" }),
        React.createElement("path", { d: "M3.5 28.25a1 1 0 0 1 1-1h23a1 1 0 1 1 0 2h-23a1 1 0 0 1-1-1Z" })));
});
